import { getLocalStorageData, saveLocalStorageData } from '@/utils/local-storage';
import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

export interface INotificationStore {
  isOnActiveCaseSoundPage: boolean;
  isOnUnassignedCaseSoundPage: boolean;
  isOnTicketingSoundPage: boolean;
  isUserSameTab: boolean;
  isOnBrowserNotification: boolean;

  // Actions
  actions: {
    setIsOnActiveCaseSoundPage: (isOnActiveCaseSoundPage: boolean) => void;
    setIsOnUnassignedCaseSoundPage: (isOnUnassignedCaseSoundPage: boolean) => void;
    setIsOnTicketingSoundPage: (isOnTicketingSoundPage: boolean) => void;
    setIsUserSameTab: (isUserSameTab: boolean) => void;
    setIsOnBrowserNotification: (isOnBrowserNotification: boolean) => void;
  };
}

export const ENABLED_SOUND_ACTIVE_CASE_KEY_V2 = 'enabled-active-case-sound-v2';
export const ENABLED_SOUND_UNASSIGNED_CASE_KEY_V2 = 'enabled-unsigned-case-sound-v2';
export const ENABLED_SOUND_TICKETING_KEY_V2 = 'enabled-ticketing-sound-v2';

export const notificationStore = create<INotificationStore>((set) => ({
  isOnActiveCaseSoundPage: false,
  isOnUnassignedCaseSoundPage: false,
  isOnTicketingSoundPage: false,
  isUserSameTab: document.visibilityState === 'visible' || document.hasFocus(),
  isOnBrowserNotification: false,

  actions: {
    setIsOnActiveCaseSoundPage: (isOnActiveCaseSoundPage: boolean) => {
      // saveLocalStorageData(ENABLED_SOUND_ACTIVE_CASE_KEY_V2, isOnActiveCaseSoundPage?.toString());
      set({ isOnActiveCaseSoundPage: isOnActiveCaseSoundPage });
    },
    setIsOnUnassignedCaseSoundPage: (isOnUnassignedCaseSoundPage: boolean) => {
      // saveLocalStorageData(ENABLED_SOUND_UNASSIGNED_CASE_KEY_V2, isOnUnassignedCaseSoundPage?.toString());
      set({ isOnUnassignedCaseSoundPage: isOnUnassignedCaseSoundPage });
    },
    setIsOnTicketingSoundPage: (isOnTicketingSoundPage: boolean) => {
      // saveLocalStorageData(ENABLED_SOUND_TICKETING_KEY_V2, isOnTicketingSoundPage?.toString());
      set({ isOnTicketingSoundPage: isOnTicketingSoundPage });
    },
    setIsUserSameTab: (isUserSameTab: boolean) => {
      set({ isUserSameTab: isUserSameTab });
    },
    setIsOnBrowserNotification: (isOnBrowserNotification: boolean) => {
      set({ isOnBrowserNotification: isOnBrowserNotification });
    },
  },
}));

export const useIsOnActiveCaseSoundPage = () => notificationStore(useShallow((state) => state.isOnActiveCaseSoundPage));
export const useIsOnUnassignedCaseSoundPage = () =>
  notificationStore(useShallow((state) => state.isOnUnassignedCaseSoundPage));
export const useIsOnTicketingSoundPage = () => notificationStore(useShallow((state) => state.isOnTicketingSoundPage));
export const useIsUserSameTab = () => notificationStore(useShallow((state) => state.isUserSameTab));
export const useIsOnBrowserNotification = () => notificationStore(useShallow((state) => state.isOnBrowserNotification));
export const useNotificationStoreActions = () => notificationStore(useShallow((state) => state.actions));
